// extracted by mini-css-extract-plugin
export var phone = "_1l-0";
export var phoneDragging = "_1l-1";